<template>
    <div>
        <bulk-selection-bar :items="files"
                            v-model="assetSelection"
                            :bulk-action-running="bulkActionRunning">
            <template v-slot:menuSlot>
                <b-dropdown variant="outline"
                            right
                            text="Change Status"
                            :disabled="bulkActionRunning"
                            v-if="selectedAssets.length > 0">

                    <b-dropdown-item @click="handleBulkStatus('approved')" :disabled="bulkActionRunning">
                        Approved
                    </b-dropdown-item>
                    <b-dropdown-item @click="handleBulkStatus('pending')" :disabled="bulkActionRunning">
                        Pending
                    </b-dropdown-item>
                </b-dropdown>
            </template>
        </bulk-selection-bar>

        <b-card class="my-3">
            <div class="mb-1 asset-avatar-select-overlay" v-for="file in files" :key="`${file.id}-${file.updated_at}`">
                <div class="bg-light p-3 d-flex align-items-center" :class="submissionAssetClass(file)">
                    <SubmissionCuratorAsset :asset="file"
                                            :tag-store="tagStore"
                                            :categories="categories"
                                            :should-prevent-save-loss="false"
                                            @assetUpdate="handleAssetUpdate"
                                            @pendingChanges="editing[file.id] = arguments[0]"
                                            :url="url">

                        <template v-slot:assetPreviewSlot>
                            <div @click.prevent.stop="handleAssetSelection(file)"
                                 class="image-select-control"
                                 :class="{ 'selection-area-expanded': selectedAssetsCount > 0 }">
                                <b-form-checkbox v-model="assetSelection[file.id]" @click.stop/>
                            </div>
                        </template>

                    </SubmissionCuratorAsset>
                </div>
            </div>
        </b-card>
    </div>

</template>

<script>
  import SubmissionCuratorAsset from "./SubmissionCuratorAsset";
  import AssetMixins from "../../../mixins/AssetMixins";
  import GeneralMixins from "../../../mixins/GeneralMixins";
  import normalize from "json-api-normalize";
  import Attributes from "../../../models/Attributes";
  import BulkSelectionBar from "../../Common/BulkSelectionBar";
  import PreventNavigationMixins from "../../../mixins/PreventNavigationMixins";

  export default {
    props: ['assets', 'url', 'tagStore', 'categories', 'submissionsUrl'],

    data: function () {
      return {
        files: this.assets,
        editing: {},
        assetSelection: {},
        bulkActionRunning: false,
        invalidAssetIds: null,
      }
    },
    components: {SubmissionCuratorAsset, BulkSelectionBar},
    mixins: [AssetMixins, GeneralMixins, PreventNavigationMixins],

    methods: {
      submissionAssetClass: function (file) {
        if (this.isInvalidAsset(file)) {
          return 'border border-danger'
        }

        if (this.assetSelection[file.id]) {
          return 'border border-primary'
        }

        return 'border border-light'
      },

      handleAssetSelection: function (file) {
        this.$set(this.assetSelection, file.id, !this.assetSelection[file.id]);
      },

      isInvalidAsset: function (asset) {
        if (!this.invalidAssetIds) return false;
        return this.invalidAssetIds.includes(asset.id)
      },

      handleSelectAll: function () {
        const selection = {};
        this.files.forEach(asset => selection[asset.id] = true);
        this.assetSelection = selection;
      },

      handleUnselectAll: function () {
        Object.keys(this.assetSelection).forEach(k => this.assetSelection[k] = false);
      },

      handleAssetUpdate: function (asset) {
        const idx = this.files.findIndex(file => file.id === asset.id);
        if (idx >= 0) this.files[idx] = asset;
        if (this.invalidAssetIds) {
          this.invalidAssetIds.splice(this.invalidAssetIds.indexOf(asset.id), 1);
        }
      },

      handleBulkStatus: function (status) {
        const assetsToAlter = this.selectedAssets.filter(img => {
          return img.status !== status;
        });

        if (assetsToAlter.length === 0) {
          return this.showErrorToast(`All of the selected assets are already ${status}`);
        }

        if (!confirm(`This action will set the status to ${status} to all selected assets that don't have this status. Do you want to continue?`)) return;

        const attributes = {
          submission: {
            assets_attributes: assetsToAlter.map(img => {
              return {
                id: img.id,
                status: status
              }
            })
          }
        };

        this.bulkActionRunning = true;

        this.$http.patch(this.submissionsUrl, attributes).then(result => {
          this.invalidAssetIds = null;
          this.files = normalize(JSON.parse(result.body.assets)).get(Attributes.assetWithIncludesAttributes);
          this.assetSelection = {};
          this.showToast("Selected assets were updated successfully", "Success")
        }, rejectionResult => {
          this.invalidAssetIds = rejectionResult.body.invalid_asset_ids;
          this.showErrorToast(null, rejectionResult.body.errors)
        }).then(result => {
          this.bulkActionRunning = false
        });
      }
    },

    computed: {
      selectedAssets: function () {
        const assetIds = Object.keys(this.assetSelection).filter(assetId => this.assetSelection[assetId] === true);
        if (assetIds.length > 0) {
          return assetIds.map(assetId => {
            return this.files.find(asset => asset.id === assetId)
          })
        }
        return [];
      },

      selectedAssetsCount: function () {
        return this.selectedAssets.length;
      },

      selectionMode: function() {
        return this.selectedAssetsCount > 0;
      }
    },

    mounted: function () {
      this.preventSaveLoss(() => {
        return Object.keys(this.editing).filter(k => this.editing[k] === true).length > 0
      });
    }
  }
</script>